import { Icon } from '@ps/isp-web-component-library';
import { StarSubIcon } from '@ps/isp-web-component-library/icons/StarSubIcon';
import React from 'react';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';

import { TXTWCL_Star_Sub_enabled_selection } from './StarSubTab.messages.json';
import styles from './StarSubTab.scss';

interface Props {
  name: string;
}

const StarSubTab: React.FC<Props> = ({ name }) => {
  const { formatMessage } = useRegulatoryIntl();
  return (
    <div className={styles.container}>
      <Icon
        icon={StarSubIcon}
        label={formatMessage(TXTWCL_Star_Sub_enabled_selection)}
        size="base"
      />
      {name}
    </div>
  );
};

export default StarSubTab;
